import "rxjs/Rx";

import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable()
export class PaperRequestService {
  constructor(private http: HttpClient) { }

  getPendingPaperRequests(created_by_ds) {
    return this.http.get(
      `/api/AccomSupportPaperRequest/getPendingPaperRequests`,
      {
        params: { value: created_by_ds },
        responseType: "json",
        observe: "response"
      }
    );
  }
  deleteRequestDetails(data) {
    return this.http.delete(`/api/Delete/deleteRecord`, {
      params: { REQUEST_ID: data.REQUEST_ID, PERSON_ID: data.PERSON_ID },
      responseType: "json",
      observe: "response"
    });
  }
  deleteDocuments(data) {
    return this.http.delete(`/api/AwsS3/deleteAllDocument`, {
      params: { PERSON_ID: data.PERSON_ID, REQUEST_ID: data.REQUEST_ID },
      responseType: "json",
      observe: "response"
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/service/paperrequest.service.ts